import { Link } from 'react-router-dom';
import type { CaseItem } from '@/lib/caseTypes';
import StatusBadge from '@/components/base/StatusBadge';

type Props = {
  hero: CaseItem;
};

const stats = [
  { value: '6', label: '追踪中事件' },
  { value: '18', label: '今日更新' },
  { value: '13', label: '累计反转节点' },
];

const HomeHero = ({ hero }: Props) => (
  <section className="border-b border-background-200 bg-background-50">
    <div className="layout-shell grid grid-cols-1 items-center gap-10 py-10 lg:grid-cols-12 lg:gap-12 lg:py-16">
      <div className="lg:col-span-7">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs font-label font-medium tracking-wide text-foreground-700">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
          2026 · 爆料后续追踪中
        </span>
        <h1 className="mt-5 font-heading text-[34px] font-black leading-[1.15] tracking-tight text-foreground-950 md:text-[52px]">
          剧情还在反转，
          <br className="hidden sm:block" />
          别急着下结论
        </h1>
        <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-foreground-600 md:text-base">
          瓜田追踪不抢首发，只把每一条爆料整理成可追溯的时间线：从最初的争议，到当事人回应、第三方核实与官方通报，让你在评论之前先看清全貌。
        </p>

        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/#hot"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-fire-line" aria-hidden="true" />
            查看今日引爆
          </Link>
          <Link
            to="/#faq"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
          >
            <i className="ri-shield-check-line" aria-hidden="true" />
            我们如何核实
          </Link>
        </div>

        <dl className="mt-9 grid max-w-md grid-cols-3 gap-4 border-t border-background-200 pt-6">
          {stats.map((s) => (
            <div key={s.label}>
              <dt className="text-xs text-foreground-500">{s.label}</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="lg:col-span-5">
        <div className="relative overflow-hidden rounded-lg border border-background-300/70 bg-background-100">
          <Link to={`/case/${hero.id}`} className="block h-64 w-full md:h-72">
            <img
              src={hero.cover}
              alt={`${hero.title} - 今日引爆追踪配图`}
              title={`${hero.title} · 瓜田追踪`}
              className="h-full w-full object-cover object-top"
            />
          </Link>
          <div className="p-5">
            <div className="flex flex-wrap items-center gap-2">
              <StatusBadge status={hero.status} />
              <span className="text-xs text-foreground-500">{hero.category}</span>
            </div>
            <h2 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
              <Link to={`/case/${hero.id}`} className="transition-colors hover:text-primary-700">
                {hero.title}
              </Link>
            </h2>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{hero.summary}</p>
            <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
              <span>{hero.handle}</span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line" aria-hidden="true" />
                {hero.readTime}阅读
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HomeHero;